<script lang="ts">
  import type { PageProps } from './$types'
  import PortableText from '#lib/components/PortableText.svelte'
  import { firstNonEmpty, isNonEmpty } from '#utils/text.js'
  import SEO from '#lib/components/SEO.svelte'

  let { data }: PageProps = $props()
  const page = $derived(data.body.page)
  const settings = $derived(data.settings)
</script>

<SEO
  title={firstNonEmpty(page.seo?.title, page.title, settings?.seo?.title) ?? 'PAPA Art Foundation'}
  description={firstNonEmpty(page.seo?.description, settings?.seo?.description) ??
    'PAPA Art Foundation page'}
  image={page.seo?.image ?? settings?.seo?.image}
  type="article"
/>

<div class="container mx-auto px-4 py-8">
  <article class="mx-auto max-w-4xl">
    <!-- Page Header -->
    <header class="mb-8">
      <h1 class="mb-4 text-4xl font-bold text-[#3d3a34]">{page.title}</h1>
      {#if isNonEmpty(page._updatedAt)}
        <p class="text-sm text-[#6b5f4c]">
          Last updated: {new Date(page._updatedAt).toLocaleDateString()}
        </p>
      {/if}
    </header>

    <!-- Page Content -->
    {#if page.body}
      <div class="prose prose-lg max-w-none">
        <PortableText body={page.body} />
      </div>
    {:else}
      <div class="py-12 text-center">
        <p class="text-lg text-[#6b5f4c]">No content available for this page.</p>
      </div>
    {/if}
  </article>
</div>
